const LK_ArrowDown =({color,width,height})=>{
    return(
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={color} viewBox="0 0 116.99 116.99">
            {/* <defs>
                <style>
                .cls-1 {
                    fill: #005c8e;
                    stroke-width: 0px;
                }
                </style>
            </defs> */}
            <path class="cls-1" d="M108.32,26.24l-47.52,63.36c-.55.73-1.39,1.16-2.31,1.16s-1.76-.42-2.31-1.16L8.67,26.24h99.65M116.99,21.9H0s52.72,70.29,52.72,70.29c1.44,1.93,3.61,2.89,5.78,2.89s4.33-.96,5.78-2.89L116.99,21.9h0Z"/>
        </svg>
    );
};

export default LK_ArrowDown;